
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4a3428"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"m10.677 2c-1.27984 0-2.31739.99492-2.31739 2.22222v2.53968h-2.88264c-.68173 0-1.25207.49632-1.31804 1.14697l-1.14626 11.30573c-.15134 1.4927 1.07207 2.7854 2.63607 2.7854h12.70256c1.564 0 2.7874-1.2927 2.636-2.7854l-1.1462-11.30573c-.066-.65065-.6363-1.14697-1.3181-1.14697h-2.88v-2.53968c0-1.2273-1.0376-2.22222-2.3175-2.22222zm2.9796 4.7619v-2.53968c0-.17533-.1482-.31746-.3311-.31746h-2.6485c-.1828 0-.331.14213-.331.31746v2.53968zm-8.66688 12.637 1.06533-10.50745c.01294-.12765.12042-.22478.24872-.22478h11.39243c.1283 0 .2358.09713.2488.22478l1.0653 10.50745c.0378.3732-.268.6963-.659.6963h-12.70256c-.391 0-.69685-.3231-.65902-.6963z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"m11.2867 16.8706c-.1964 0-.3856-.0811-.5259-.2283l-1.87201-1.9652c-.28759-.3019-.28759-.795 0-1.0965.28759-.3019.75733-.3019 1.0446 0l1.33221 1.3984 2.7768-3.1796c.2733-.3165.7434-.3387 1.0446-.0443.3015.287.3226.7804.0422 1.0966l-3.2955 3.7688c-.1331.1546-.3295.2501-.533.2501z"}})])])
          )
        }
      }
    